export enum InstructionType {
    NotInstructed = 0,
    CoolingOff,
    ConsideringOptions,
    Instructed,
}
